"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */
var _default = {
  presence: {
    batcherWait: 50,
    batcherMaxCalls: 50,
    batcherMaxWait: 150
  }
};
exports.default = _default;
//# sourceMappingURL=config.js.map
